/* Rorilio · PDP Labial Signature : galerie, packs + ajout panier (moteur d'offres Rorilio), minuteur minuit America/Mexico_City, FAQ, carrousel de commentaires mobile. */
(function () {
  if (window.__lsPdp) return; window.__lsPdp = true;
  function $all(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    /* Minuteur : fin à minuit heure du marché, redémarre chaque jour (masqué après la date de fin si renseignée). */
    function tzNow(tz) {
      try {
        var p = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
        var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
        return { date: o.year + '-' + o.month + '-' + o.day, secs: (parseInt(o.hour, 10) % 24) * 3600 + parseInt(o.minute, 10) * 60 + parseInt(o.second, 10) };
      } catch (e) { var d = new Date(); return { date: d.toISOString().slice(0, 10), secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds() }; }
    }
    function two(n) { return (n < 10 ? '0' : '') + n; }
    var timers = $all('[data-ls-timer]');
    function tick() {
      timers.forEach(function (el) {
        var n = tzNow(el.getAttribute('data-tz') || 'America/Mexico_City'), until = el.getAttribute('data-until') || '';
        if (until && n.date > until) { el.parentNode.style.visibility = 'hidden'; return; }
        var rest = 86400 - n.secs; if (rest >= 86400) rest = 0;
        el.textContent = two(Math.floor(rest / 3600)) + ':' + two(Math.floor(rest / 60) % 60) + ':' + two(rest % 60);
      });
    }
    if (timers.length) { tick(); setInterval(tick, 1000); }

    /* Galerie */
    $all('[data-ls-gal]').forEach(function (g) {
      var sl = g.querySelector('.ls-gal__slides'), th = $all('.ls-gal__thumb', g), n = th.length, box = g.querySelector('.ls-gal__thumbs');
      if (!n) return;
      function mark(i) { th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); var t = th[i]; if (t && box) box.scrollLeft = t.offsetLeft - box.offsetLeft - 40; }
      function go(i) { i = (i + n) % n; sl.scrollTo({ left: sl.clientWidth * i, behavior: 'smooth' }); mark(i); }
      th.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var p = g.querySelector('.ls-gal__arrow--p'), nx = g.querySelector('.ls-gal__arrow--n');
      if (p) p.addEventListener('click', function () { go(Math.round(sl.scrollLeft / sl.clientWidth) - 1); });
      if (nx) nx.addEventListener('click', function () { go(Math.round(sl.scrollLeft / sl.clientWidth) + 1); });
      var w; sl.addEventListener('scroll', function () { clearTimeout(w); w = setTimeout(function () { mark(Math.round(sl.scrollLeft / (sl.clientWidth || 1))); }, 80); }, { passive: true });
    });

    /* Packs + ajout : une seule variante, le pack règle la quantité ; le moteur rorilio-offers.js pose le code du palier. */
    $all('[data-ls-buy]').forEach(function (b) {
      var packs = $all('[data-pack]', b), atc = b.querySelector('[data-atc]'), err = b.querySelector('[data-err]');
      var sel = b.querySelector('[data-pack].is-on') || packs[0];
      function paint() { packs.forEach(function (p) { var on = p === sel; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); }); }
      packs.forEach(function (p) {
        p.addEventListener('click', function () { sel = p; paint(); });
        p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sel = p; paint(); } });
      });
      function fail(e) { atc.classList.remove('is-busy'); if (err) { err.textContent = (e && e.message) || 'Error'; err.hidden = false; } }
      if (atc) atc.addEventListener('click', function () {
        var q = parseInt(sel.getAttribute('data-qty'), 10) || 1, vid = parseInt(b.getAttribute('data-variant'), 10);
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var RO = window.RorilioOffers;
        if (!RO) { location.href = root + 'cart/add?id=' + vid + '&quantity=' + q; return; }
        atc.classList.add('is-busy'); if (err) err.hidden = true;
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: q }] }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error'); return j; }); })
          .then(function () { return RO.reconcile(true); })
          .then(function (st) {
            atc.classList.remove('is-busy');
            if (st) delete st._silent;
            if (!st || !st.sections || !RO.open(st)) location.href = root + 'cart';
          })
          .catch(fail);
      });
      paint();
    });

    /* FAQ (une seule ouverte à la fois par liste) */
    $all('[data-ls-faq]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var q = e.target.closest('.ls-faq__q'); if (!q) return; var it = q.parentElement, open = it.classList.contains('is-open');
        $all('.ls-faq__it', list).forEach(function (i) { i.classList.remove('is-open'); i.querySelector('.ls-faq__q').setAttribute('aria-expanded', 'false'); i.querySelector('.ls-faq__a').hidden = true; });
        if (!open) { it.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); it.querySelector('.ls-faq__a').hidden = false; }
      });
    });

    /* 3 étapes : carrousel en mobile */
    $all('[data-ls-steps]').forEach(function (s) {
      var g = s.querySelector('.ls-steps__grid'), dots = $all('.ls-steps__dot', s), n = dots.length;
      function idx() { return Math.round(g.scrollLeft / (g.clientWidth || 1)); }
      function go(i) { i = (i + n) % n; g.scrollTo({ left: g.clientWidth * i, behavior: 'smooth' }); }
      $all('.ls-steps__btn', s).forEach(function (b) { b.addEventListener('click', function () { go(idx() + parseInt(b.getAttribute('data-dir'), 10)); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      var t; g.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var k = idx(); dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); }); }, 80); }, { passive: true });
    });

    /* Commentaires : carrousel 1 par 1 en mobile */
    $all('[data-ls-fb]').forEach(function (s) {
      var track = s.querySelector('.ls-fb__track'), clip = s.querySelector('.ls-fb__clip'), dots = $all('.ls-fb__dot', s), n = track.children.length, cur = 0;
      function mob() { return window.innerWidth <= 749; }
      function go(i) {
        if (!mob()) { track.style.transform = ''; return; }
        cur = (i + n) % n; track.style.transform = 'translateX(' + (-cur * clip.offsetWidth) + 'px)';
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === cur); });
      }
      s.querySelector('.ls-fb__btn--p').addEventListener('click', function () { go(cur - 1); });
      s.querySelector('.ls-fb__btn--n').addEventListener('click', function () { go(cur + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      var sx = 0;
      track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); }, { passive: true });
      window.addEventListener('resize', function () { go(cur); }); go(0);
    });
  });
})();
